"use client";
import { jsx as C, Fragment as e } from "react/jsx-runtime";
import { createSvgIcon as r } from "@mui/material/utils";
const t = r(
  /* @__PURE__ */ C(e, { children: /* @__PURE__ */ C(
    "path",
    {
      d: "M14.36 2.64002L22.32 16.66H22.31C22.8 17.51 22.79 18.52 22.3 19.36C21.81 20.21 20.94 20.71 19.96 20.71H4.02999C3.05999 20.71 2.17999 20.2 1.68999 19.36C1.19999 18.52 1.19999 17.51 1.67999 16.66L9.63999 2.64002C10.13 1.78002 11.01 1.27002 12 1.27002C12.99 1.27002 13.87 1.78002 14.36 2.64002ZM19.97 19.29C20.43 19.29 20.85 19.05 21.08 18.65H21.09C21.32 18.25 21.32 17.76 21.09 17.36L13.12 3.34002C12.89 2.93002 12.47 2.69002 12 2.69002C11.53 2.69002 11.11 2.93002 10.88 3.34002L2.90999 17.36C2.66999 17.77 2.67999 18.25 2.90999 18.65C3.14999 19.05 3.56999 19.29 4.02999 19.29H19.97ZM10.95 7.39998L11.29 13.5C11.34 14.38 12.66 14.38 12.71 13.5L13.05 7.39998V7.27998C12.95 5.89998 10.89 6.00998 10.94 7.39998H10.95ZM12 17.61C12.5523 17.61 13 17.1623 13 16.61C13 16.0577 12.5523 15.61 12 15.61C11.4477 15.61 11 16.0577 11 16.61C11 17.1623 11.4477 17.61 12 17.61Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxWarningStroked"
);
export {
  t as default
};
